const auxColor = new THREE.Color();

AFRAME.registerComponent('supercutfx', {
  schema: {
    colorPrimary: {type: 'string'},
    colorSecondary: {type: 'string'}
  },

  init: function () {
    this.rigEl = document.getElementById('curveFollowRig');
    this.startTime = -1100; // Pause on first tick.
  },

  createSuperCut: function (beatObject3D, color) {
    const el = this.el;
    const mesh = this.el.getObject3D('mesh');

    mesh.material.transparent = true;
    this.rigEl.object3D.worldToLocal(el.object3D.position.copy(beatObject3D.position));
    el.object3D.position.z -= 0.25;
    el.object3D.visible = true;

    this.startTime = el.sceneEl.time;

    auxColor.set(color === 'red' ? this.data.colorPrimary : this.data.colorSecondary);
    const colorUniform = mesh.material.uniforms.color.value;
    colorUniform.x = auxColor.r;
    colorUniform.y = auxColor.g;
    colorUniform.z = auxColor.b;
    mesh.material.uniforms.startTime.value = this.startTime - 50;
    el.play();
  },

  tick: function (time) {
    if (time > this.startTime + 1000) {
      this.el.object3D.visible = false;
      this.el.pause();
    }
  }
});
if (module.hot && window.AFRAME) {
  const componentNames = ['supercutfx',];

  const shaderNames = [];

  const systemNames = [];

  // Clean up from application when module is unloaded.
  module.hot.dispose(data => {
    let els;
    data.needsReplace = true;

    componentNames.forEach(component => {
      // Unregister.
      delete AFRAME.components[component];
      const els = AFRAME.scenes[0].querySelectorAll(`[${component}]`);
      for (let i = 0; i < els.length; i++) {
        if (!els[i].isEntity) { continue; }
        // Store data.
        els[i].setAttribute(`data-__hot-${component}`,
                            JSON.stringify(els[i].getDOMAttribute(component)));
        // Detach component.
        els[i].removeAttribute(component);
      }
    });

    shaderNames.forEach(shader => {
      // Unregister.
      delete AFRAME.shaders[shader];
      const els = AFRAME.scenes[0].querySelectorAll(`[material]`);
      for (let i = 0; i < els.length; i++) {
        if (!els[i].isEntity) { continue; }
        // Store data.
        if (els[i].getAttribute('material').shader !== shader) { continue; }
        els[i].setAttribute('data-__hot-material', JSON.stringify(
          els[i].getDOMAttribute('material')));
        // Detach material.
        els[i].removeAttribute('material');
      }
    });

    systemNames.forEach(system=> {
      delete AFRAME.systems[system];
      delete AFRAME.scenes[0].systems[system];
    });
  });

  if (module.hot.data && module.hot.data.needsReplace) {
    // Apply component back to entities.
    componentNames.forEach(componentName => {
      const dataAttrName = `data-__hot-${componentName}`;
      const els = document.querySelectorAll(`[${dataAttrName}]`);
      for (let i = 0; i < els.length; i++) {
        els[i].setAttribute(componentName, JSON.parse(els[i].getAttribute(dataAttrName)), true);
        els[i].removeAttribute(dataAttrName);
      }
    });

    // Apply materials back.
    const dataAttrName = 'data-__hot-material';
    const els = document.querySelectorAll(`[${dataAttrName}]`);
    for (let i = 0; i < els.length; i++) {
      els[i].setAttribute('material', JSON.parse(els[i].getAttribute(dataAttrName)), true);
      els[i].removeAttribute(dataAttrName);
    }
  }

  module.hot.accept();
}
